module.exports = __webpack_public_path__ + "static/babyannouncevestmain-78fc9dd00edba73792c8e2423248bc67.jpeg";